import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import CallMadeRoundedIcon from '@mui/icons-material/CallMadeRounded';
import CallReceivedRoundedIcon from '@mui/icons-material/CallReceivedRounded';

const ContactContainer = styled('div')({
  display: 'flex',
  padding: '0.7rem 1rem',
  flexDirection: 'column',
  borderTop: '1px solid lightgray',
  borderBottom: '1px solid lightgray',
});

type CustomerContactProps = {
  name: string;
  lastMessage: string;
  date: string;
  type: string;
};

export default class CustomerContact extends React.Component<CustomerContactProps> {
  render() {
    return (
      <ContactContainer>
        <span
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant='h6'>{this.props.name}</Typography>
          <Typography variant='body2' style={{ color: 'gray' }}>
            {this.props.date}
          </Typography>
        </span>
        <span style={{ display: 'flex' }}>
          <Typography variant='body2'>
            {this.props.type === 'send' ? (
              <CallMadeRoundedIcon
                style={{
                  fontSize: '1rem',
                  marginRight: '5px',
                  color: '#844949',
                }}
              />
            ) : (
              <CallReceivedRoundedIcon
                style={{
                  fontSize: '1rem',
                  marginRight: '5px',
                  color: '#844949',
                }}
              />
            )}
          </Typography>
          <Typography variant='body2'>{this.props.lastMessage}</Typography>
        </span>
      </ContactContainer>
    );
  }
}
